module.exports = __webpack_public_path__ + "static/media/gb-wls.acae1774.svg";